module.exports = __webpack_public_path__ + "img/20220219_071928.624a0ec0.jpg";